import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { ISuEditorForm } from 'KnmPackage/StructureRequirementsNpaModule/interface';

const emptyMessage = 'Поле не может быть пустым';
const required = makeRequired(emptyMessage);

export const SuValidator = (values: ISuEditorForm) => {
  return {
    newStructuralUnits: values.newStructuralUnits.map(item => ({
      components: item.components?.map(comp => ({
        selectType: required(comp.selectType),
        value: required(comp.value),
      })),
      mandatoryRequirements: item.mandatoryRequirements?.map(i => required(i)),
    })),
  };
};
